// extracted by mini-css-extract-plugin
export var defaultWrapper = "_in-3";
export var downloadButton = "_in-4";
export var fileContainer = "_in-9 _in-7";
export var fileContainerBase = "_in-7";
export var fileContainerFixedHeight = "_in-8 _in-7";
export var fileInfo = "_in-5";
export var fileInfoWidthRestricted = "_in-6";
export var fileType = "_in-1";
export var fileTypeName = "_in-2";
export var image = "_in-0";
export var link = "_in-b";
export var overflowEllipsis = "_in-a";